import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Configuration } from 'app/app.configuration';
import { DataService } from 'app/shared/common/helper/http-service';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {
  isButton: boolean;
  displayedColumns: string[] = ['compare', 'standard', 'enterprise'];
  dataSource = [
    { compare: 'Employees', standard: '15', enterprise: 'Unlimited', isButton: false },
    { compare: 'Screenshots', standard: '5000', enterprise: 'Unlimited', isButton: false },
    { compare: 'Projects', standard: '15', enterprise: '50', isButton: false },
    { compare: '', standard: '', enterprise: '', isButton: true }
  ];
  sessionId: string;
  tenantId: string;
  customerStripeData: any;
  customerId: any;
  updateUrl: any;
  isActive: boolean = false;
  subscribedPlanData: any;
  subscriptionId: any;
  subscribedCustomerId: any;
  enterpriseId: any;
  standardId: any;
  isEnterprise: boolean;
  isStandard: boolean = false;

  constructor(private dataService: DataService,
    private configuration: Configuration,
    private route: ActivatedRoute,
    private storageConfiguration: StorageConfiguration,
    private parseService: ParseService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit() {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.route.queryParams.subscribe(params => {
      this.sessionId = params.session_id;
    })
    this.getPlanDetails();
    this.getSubscribedPlan();
    this.getSubscritionId();
  }

  //get all the plan details
  getPlanDetails(){
    let results = [];
    this.dataService.getAllPlan(this.configuration.planDetails).subscribe((result: any) => {
      for(let resultdata of result.data ){
        results.push({
          priceId : resultdata.id
        })
      }
      this.enterpriseId = results[0].priceId;
      this.standardId = results[1].priceId;
    })
  }

  //get subscription details from stripe for specific customer using sessionId
  getSubscritionId() {
    if (this.sessionId != undefined) {
      let results = [];
      this.dataService.getSingle(this.sessionId, this.configuration.planSubscription + '/').subscribe((result: any) => {
        results.push({
          customerId: result.data.customer,
          subscriptionId: result.data.subscription,
          nextInvoiceDate: new Date(1000 * result.data.expires_at)
        });
        this.customerStripeData = results[0];
        this.updateCustomer();
      });
    }
  }

  //update customer table 
  async updateCustomer() {
    let updateCustomer = this.parseService.instance.Object.extend('Customer');
    let query = new this.parseService.instance.Query(updateCustomer);
    query.equalTo('tenantId', this.tenantId);
    let result = await query.find();
    let updateCustomerDetails = result[0];
    updateCustomerDetails.set('customerId', this.customerStripeData.customerId);
    updateCustomerDetails.set('subscriptionId', this.customerStripeData.subscriptionId);
    updateCustomerDetails.save().then((res) => {
      this.customerId = res.id;
    });
  }

//get subcribed plan details to highlight the selected plan
  async getSubscribedPlan(){
    this.spinner.show();
    let Customer = this.parseService.instance.Object.extend('Customer');
    let query = new this.parseService.instance.Query(Customer);
    query.equalTo('tenantId', this.tenantId);
    await query.find().then(res => {
      if (res[0].attributes.subscriptionId === undefined || res[0].attributes.subscriptionId === '') { 
        this.spinner.hide();
        return;
       }
      this.subscriptionId = res[0].attributes.subscriptionId;
      this.subscribedCustomerId = res[0].attributes.customerId;
    })
    let results = [];
    this.dataService.getSingle(this.subscriptionId, this.configuration.subscribedPlanDetails + '/').subscribe((result: any) => {
      results.push({
        priceId: result.data.plan.id,
        productId : result.data.plan.product,
        startDate : new Date(1000*result.data.current_period_start),
        endDate : new Date(1000*result.data.current_period_end),
        subscribedAmount : result.data.plan.amount,
        status: result.data.plan.active
      });
      this.subscribedPlanData = results[0];
      this.isActive = this.subscribedPlanData.status;
      if(this.subscribedPlanData.priceId == this.enterpriseId){
        this.isEnterprise = true;
      } else if (this.subscribedPlanData.priceId == this.standardId){
        this.isStandard = true;
      }
      this.spinner.hide();
      this.createCustomerPlan();
      this.upgradeCustomerPlan();
    })
  }

  //create cutomer plan table to store plan details
 async createCustomerPlan() {
    const CustomerPlan = this.parseService.instance.Object.extend('CustomerPlan');
    const customerPlanQuery = new this.parseService.instance.Query(CustomerPlan)
    customerPlanQuery.equalTo('tenantId', this.tenantId);
    customerPlanQuery.equalTo('customerId', { __type: 'Pointer', className: 'Customer', objectId: this.subscribedCustomerId });
    const customerUpdate =  await customerPlanQuery.find()
    if(customerUpdate.length > 0){
      this.customerPlan(customerUpdate[0], 'update')
    } else {
      this.customerPlan(new CustomerPlan(), 'create')
    }
  }

  customerPlan(CustomerPlan, type){
    // if(type === 'create'){
    //   var customerPlan = new CustomerPlan();
    // }
    CustomerPlan.set('tenantId', this.tenantId);
    CustomerPlan.set('customerId', { __type: 'Pointer', className: 'Customer', objectId: this.subscribedCustomerId });
    CustomerPlan.set('status', 'active');
    CustomerPlan.set('subscriptionId', this.subscriptionId);
    CustomerPlan.set('planPriceId', this.subscribedPlanData.priceId);
    CustomerPlan.set('productId', this.subscribedPlanData.productId);
    CustomerPlan.set('startDate', this.subscribedPlanData.startDate);
    CustomerPlan.set('endDate', this.subscribedPlanData.endDate);
    CustomerPlan.set('status', 'active');
    CustomerPlan.save().then((res) => {
      let toasterText = type === 'create' ? 'Created Successfully' : 'Updated Successfully';
      this.toastr.success(toasterText);
    });
    }

  //upgrade the customer plan
  upgradeCustomerPlan() {
    let data = {
      customerId: this.subscribedCustomerId
    }
    this.dataService.add(this.configuration.updatePlanSubscription, data).subscribe((result: any) => {
      this.updateUrl = result.data;
    })
  }

}
